<template>
  <div>
    <el-scrollbar wrap-class="scrollbar-wrapper" style="z-index:10">
      <logo :collapse="isCollapse" />
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="variables.menuBg" style="overflow-y:hidden;"
        :text-color="variables.menuText" :active-text-color="variables.menuActiveText" :unique-opened="true"
        :collapse-transition="false" mode="vertical">
        <sidebar-item v-for="route in $store.state.sys.permissionRouters" :key="route.path" :item="route"
          :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
    <!-- <van-overlay ref="overlay" :show="$store.state.app.sidebar.opened" click="hideMenu" /> -->
    <!-- <div style="height:100%;width:100;background:rgba(0,0,0)"></div> -->
  </div>
</template>

<script>
import variables from "@/styles/variables.scss";
import logo from "./logo";
import sidebarItem from "./sidebarItem";

export default {
  components: {
    sidebarItem,
    logo
  },
  data() {
    return {
      operationDialog: false,
      contactDialog: false,
      headerHeight: "120px",
      openedMenus: [],
      currentMenus: [],
      menuPath: "",
      maxShowHeaderMenu: 0,
      path: ""
    };
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      // if(this.$store.state.isMB){
      //   this.$store.dispatch("MBtoggleSideBar");
      // }
      return path;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.$store.state.app.sidebar.opened;
    }
  }
};
</script>